import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Login from "./pages/Login";
import Category from "./pages/Category";
import Research from "./pages/Research";
import OpportunityList from "./pages/Opportunities";
import PrivateRoute from "./components/PrivateRoute";

const theme = createTheme({
  typography: {
    fontFamily: '"Roboto Slab", serif',
    fontWeightLight: 400,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
    fontWeightBold: 700,
    allVariants: {
      fontWeight: 600,
    },
  },
  palette: {
    primary: {
      main: "#002D72",
    },
    secondary: {
      main: "#dc004e",
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/category"
            element={
              <PrivateRoute>
                <Category />
              </PrivateRoute>
            }
          />
          <Route
            path="/research"
            element={
              <PrivateRoute>
                <Research />
              </PrivateRoute>
            }
          />
          <Route
            path="/research/:id"
            element={
              <PrivateRoute>
                <Research />
              </PrivateRoute>
            }
          />
          <Route path="/resources-and-opportunities" element={<OpportunityList />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
